// const options = [
//   { value: 'todos', label: 'Todos' },
// ];

// const options2 = [
//   { value: 'lucas', label: 'lucas' },
//   { value: 'rebeca', label: 'rebeca' },
// ];

// const ReceiverInput = () => {
//   const [state, setState] = React.useState({
//     selectedOption: null,
//     options,
//   });

//   const handleChange = (selectedOption) => {
//     setState({ selectedOption });
//   };

//   const onInputChange = (input) => {
//     if (input && input.length) {
//       setState({ ...state, options: options2 });
//     } else {
//       setState({ ...state, options });
//     }
//   };

//   return (
//     <Select
//       value={state.selectedOption}
//       options={state.options}
//       onChange={handleChange}
//       onInputChange={onInputChange}
//     />
//   );
// };

// export default ReceiverInput;

import React from 'react';
import Select from 'react-select';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import CancelIcon from '@material-ui/icons/Cancel';
// import Avatar from '@material-ui/core/Avatar';
import FaceIcon from '@material-ui/icons/AccountCircle';
import GroupIcon from '@material-ui/icons/SupervisedUserCircle';
// import GroupIcon from '@material-ui/icons/Group';


// Div de resultado não encontrado
function NoOptionsMessage(props) {
  return (
    <Typography
      color="textSecondary"
      style={{ padding: '0.5em 1em'}}
      {...props.innerProps}
    >
      Nenhum resultado encontrado
    </Typography>
  );
}

// Div do input ( select + botões )
function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} style={{ display: 'flex', height: 'auto' }} />;
}
// Div de controle do campo do input
function Control(props) {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );
}

// Componente das opções
function Option(props) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}
// Div que contém o input e os chips
function ValueContainer(props) {
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        flex: 1,
        alignItems: 'center',
        overflow: 'hidden',
      }}
    >
      {props.children}
    </div>
  );
}

function MultiValue(props) {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      onDelete={props.removeProps.onClick}
      style={{ backgroundColor: '#eee', margin: '0.25em 0.125em' }}
      icon={(
        props.data.isDepartment ?
          <GroupIcon {...props.removeProps} /> :
          <FaceIcon />
        )}
      deleteIcon={<CancelIcon {...props.removeProps} />}
    />
  );
}

// Componente que carrega as opções
function Menu(props) {
  return (
    <Paper square style={{ position: 'absolute', zIndex: 1, width: '100%' }} {...props.innerProps}>
      {props.children}
    </Paper>
  );
}

const components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  ValueContainer,
};

// ********* //

const ReceiverInput = ({ data, onValueChange }) => {
  const defaultOptions = [
    { value: 'todos', label: 'Todos', isDepartment: true },
  ];
  const [state, setState] = React.useState({
    selectedOption: null,
    options: defaultOptions,
  });

  const handleChange = (selectedOption) => {
    onValueChange(selectedOption);
    setState({ selectedOption });
  };

  const onInputChange = (input) => {
    if (input && input.length) {
      setState({ ...state, options: data });
    } else {
      setState({ ...state, options: defaultOptions });
    }
  };

  return (
    <div>
      <Select
        textFieldProps={{
          label: 'Para',
          InputLabelProps: {
            shrink: true,
          },
        }}
        components={components}
        placeholder="Busque por departamento ou funcionário"
        isMulti
        value={state.selectedOption}
        options={state.options}
        onChange={handleChange}
        onInputChange={onInputChange}
      />
    </div>
  );
};

export default ReceiverInput;
